import React, { useState } from "react";

export default function PopConfirm(props) {
  const [visible, setVisible] = useState(false);

  const togglePop = () => {
    setVisible(!visible);
  };

  return (
    <>
      <span
        onClick={() => {
          togglePop();
        }}
      >
        {props.children}
      </span>
      <div className="relative">
        <div
          className={`absolute -top-20 mx-auto p-4 border w-64 shadow-lg rounded-md bg-white ${
            !visible && "hidden"
          } ${props?.left && "-left-56"}`}
        >
          <div className="text-lg font-bold">
            <span>{props.title}</span>
          </div>
          <div className="flex mt-2">
            <button
              className="flex-1 border rounded mr-2 p-1"
              onClick={() => {
                togglePop();
              }}
            >
              No
            </button>
            <button
              className="flex-1 p-1 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
              onClick={() => {
                props.onConfirm();
                togglePop();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
